"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INBOUND_PKG_MAX_SKUS_PER_BOX = void 0;
exports.INBOUND_PKG_MAX_SKUS_PER_BOX = 20;
//# sourceMappingURL=PackageConstants.js.map